import React, { Component } from 'react';

import {connect} from "react-redux";
import {PropTypes} from "prop-types";
import DatePicker from "react-datepicker";
import SelectBox from "../../../etc/SelectBox"
import Popup from "../../../etc/Popup"

import {bindActionCreators} from "redux";
import * as Actions from "../../../../store/modules/journals";
import {getObjectLength, objectToQueryString, pushUrl, getNumberFormat, getSelectFormat} from "../../../../utils/functions"

import {BASE_PATH, JOURNAL_FACET_NAME, FACET_ORDER} from "../../../../wpconfig"

import * as func from "../../../../utils/functions";

class SearchSide extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
    }

    handleGoto(url) {
    }

    handlePageClick = (data) => {
    }

    render() {
        return (
            <div className="right-side-group">
                <div className="side-contents-group line">
                    <h4 className="con-title d-flex align-items-center mb-3">
                        <span className="icon icon-size-16 icon-document-blue mr-2" />최신 보고서(준비중)</h4>
                    <div>
                        <a href="#" className="btn-side-link-item mb-20">
                            <div className="item-title">GUNTER NARR VERLAG</div>
                            <div className="item-name">한국기계연구원 김왕종 박사</div>
                        </a>
                        {/*<a href="#" className="btn-side-link-item mb-20">*/}
                        {/*    <div className="item-title">GUNTER NARR VERLAG</div>*/}
                        {/*    <div className="item-name">한국기계연구원 정정훈 박사</div>*/}
                        {/*</a>*/}
                        {/*<a href="#" className="btn-side-link-item">*/}
                        {/*    <div className="item-title">GUNTER NARR VERLAG</div>*/}
                        {/*    <div className="item-name">한국기계연구원 정정훈 박사</div>*/}
                        {/*</a>*/}
                    </div>
                </div>
                <div className="side-contents-group line">
                    <h4 className="con-title d-flex align-items-center mb-3">
                        <span className="icon icon-size-16 icon-graph-blue mr-2" />주요 통계(준비중)</h4>
                    <div>
                        <a href="#" className="btn-side-link-item mb-20">
                            <div className="item-title">파이썬으로 배우는 기계학습 입문</div>
                            <div className="item-name">부산대, 한국과학기술원, 포항공대 강좌 종료 (청강가능)</div>
                        </a>
                        {/*<a href="#" className="btn-side-link-item mb-20">*/}
                        {/*    <div className="item-title">파이썬으로 배우는 기계학습 입문</div>*/}
                        {/*    <div className="item-name">서울대, 한국과학기술원, 포항공대 강좌 종료 (청강가능)</div>*/}
                        {/*</a>*/}
                        {/*<a href="#" className="btn-side-link-item">*/}
                        {/*    <div className="item-title">파이썬으로 배우는 기계학습 입문</div>*/}
                        {/*    <div className="item-name">서울대, 한국과학기술원, 포항공대 강좌 종료 (청강가능)</div>*/}
                        {/*</a>*/}
                    </div>
                </div>
                <div className="side-contents-group line">
                    <h4 className="con-title d-flex align-items-center mb-3">
                        <span className="icon icon-size-16 icon-graph-blue mr-2" />학과 통계(준비중)</h4>
                    <div>
                        <a href="#" className="btn-side-link-item mb-2">
                            <div className="item-title">우리나라 비목별 연구개발비</div>
                        </a>
                        {/*<a href="#" className="btn-side-link-item mb-2">*/}
                        {/*    <div className="item-title">우리나라 비목별 연구개발비</div>*/}
                        {/*</a>*/}
                        {/*<a href="#" className="btn-side-link-item">*/}
                        {/*    <div className="item-title">우리나라 비목별 연구개발비</div>*/}
                        {/*</a>*/}
                    </div>
                </div>
            </div>
        )
    }
}

export default SearchSide;

// SearchSide.propTypes = {
//     param : PropTypes.object,
//     facet : PropTypes.object,
// };
